import React from 'react'
import Nav from "../components/Nav/nav";
import Whatsapp from '../Whatsapp/whatsapp';
import EprofGro from "../components/GeneralRegisterOfficer/groadmin/empProf"

const GroEProf = () => {
  return (
    <div>
      <Nav />
     <EprofGro/>
     <Whatsapp/>
    </div>
  )
}

export default GroEProf